import { Container } from 'inversify'

import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindEventNotificationHooks(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.EventNotificationHooks)
    .toDynamicValue(() => {
      return []
    })
    .inSingletonScope()
}
